import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import config from "./config.json";
import axios from "axios";
import Email from "./components/EmailSection/email";
import FullCalendar from "./components/Calendar/Calendar";
import ClientBody from "./components/Accounts/ClientBody";
import DealList from "./components/Deal/DealList";
import Createdeal from "./components/Deal/createdeal/createdeal";
import Body from "./common/body/body";
// import ProjectTasks from "./components/ProjectTasks/ProjectTasks";
import CreateVendor from "./components/Vendors/createVendor/createVendor";
import VendorList from "./components/Vendors/vendorList";
import Users from "./components/Users/Users";
import Setting from "./components/Setting/Setting";
import DocumentTree from "./components/Documents/DocumentTree";
import Roles from "./components/Roles/Roles";
import { UserRole } from "./components/User Role/UserRole";
import Teams from "./components/Teams/Teams";
import HRTimeClock from "./components/HR/TimeClock/HR";
import EmailTemplates from "./components/TaskBluePrints/EmailTemplates";
import TaskBlueprints from "./components/TaskBluePrints/TaskBlueprints";
import ClientList from "./components/Accounts/ClientList";
import CreateClient from "./components/Accounts/CreateClient";
import SubHeader from "./common/subheader/SubHeader";
import { lazy, Suspense, useEffect, useRef, useState } from "react";
import SkeletonUIHeader from "./components/ProjectTasks/SkeletonUIHeader";
import ApplicationProfiles from "./components/TaskBluePrints/SecurityControls/ApplicationProfiles";
import ReportBug from "./navbar/ReportBug";

const ProjectTasks = lazy(() =>
  import("./components/ProjectTasks/ProjectTasks")
);

const AppRoutes = ({
  getToken,
  allUsers,
  helperFnGetTokenFromCode,
  setLoader,
  ApproutesParams
}) => {
  const [routesParams, setRoutesParams] = useState({});
  let history = useHistory();
  let location = useLocation();
  location.state = routesParams;
  
  useEffect(() => {
    if(history.location.pathname=="/" && ApproutesParams){
      history.push({pathname:"/", state:{}})
      setRoutesParams({});
      location.state = {};
    }
  },[ApproutesParams])
  useEffect(
    (e) => {
      if (history && history.replace) {
        var currentURL = window.location.href;
        // Check if the previous entry in the history is the same as the current URL
        if (history.state && history.location.pathname === currentURL) {
          history.replace(null, "", currentURL);
        }
      }
    },
    [history.location]
  );
  const getParams = (params) => {
    location.state = params;
    setRoutesParams(params);
  };
  console.log("Locatio in AppRoute:- ", location);
  const [showExitPrompt, setShowExitPrompt] = useState(false);
  const [checkType, setCheckType] = useState({ type: "" });
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteDealFlag, setDeleteDealFlag] = useState();
  const [rendering, setRendering] = useState(true);
  const [clientListStatus, setClientListStatus] = useState({
    EditColumns: undefined,
    SaveAsView: undefined,
    ActiveTab: undefined,
    ExcelDownload: undefined,
    ShouldSave: false,
  });
  const clientListTriggers = (data) => { 
    if (data.type == "EditColumns") {
      setClientListStatus({
        ...clientListStatus,
        EditColumns: data.status ? data.status : !clientListStatus.EditColumns,
      });
    } else if (data.type == "SaveAsView") {
      setClientListStatus({
        ...clientListStatus,
        SaveAsView: data.status,
      });
    } else if (data.type == "SetActiveTab") {
      setClientListStatus({
        ...clientListStatus,
        ActiveTab: data.status,
      });
    } else if (data.type == "downloadExcel") {
      setClientListStatus({
        ...clientListStatus,
        ExcelDownload: data.status,
      });
    } else if (data.type == "ShouldSave") {
      setClientListStatus({
        ...clientListStatus,
        ShouldSave: data.status,
      });
    }
  };

  const [sidebarCardsStatus, setSidebarCardsStatus] = useState({
    Preliminary: false,
    NycProject: false,
    Homeowner: false,
    Permitting: false,
    PVSystem: false,
  });

  const [dealListStatus, setDealListStatus] = useState({
    EditColumns: undefined,
    SaveAsView: undefined,
    ActiveTab: undefined,
    ExcelDownload: undefined,
  });
  const dealListTriggers = (data) => {
    if (data.type == "EditColumns") {
      setDealListStatus({
        ...dealListStatus,
        EditColumns: data.status ? data.status : !dealListStatus.EditColumns,
      });
    } else if (data.type == "SaveAsView") {
      setDealListStatus({
        ...dealListStatus,
        SaveAsView: data.status,
      });
    } else if (data.type == "SetActiveTab") {
      setDealListStatus({
        ...dealListStatus,
        ActiveTab: data.status,
      });
    } else if (data.type == "downloadExcel") {
      setDealListStatus({
        ...dealListStatus,
        ExcelDownload: data.status,
      });
    }
  };

  const saveCancelButtonRef = useRef();
  const clickActionOfSaveAndCancelButton = (d) => {
    saveCancelButtonRef.current.saveButtonClick();
  };
  const toggelActiveBar = (d) => {
    saveCancelButtonRef.current.toggelActiveBar(d);
  };
  const handleClickDownloadViolationFromWorkdrive = async (fileData) => {
    let baseUrl = `${config.backend_aws_server_url}catalyApi/getPriviewFileById`;
    let payLoad = {
      fileId: fileData,
      accessToken: localStorage.getItem("token"),
    };
    let str = "";
    await axios.post(baseUrl, payLoad).then((r) => {
      str = r.data;
    });
    return str;
  };
  const fetchAuthenticatedUrl = async ({ info, type, fileId }) => {
    let uri = "";
    let returnObject = {
      DataUrl: "",
      ShowPrevModal: false,
      FileName: "",
    };
    //setLoader(true);
    try {
      let data;
      if (fileId != "" && fileId != undefined) {
        data = await handleClickDownloadViolationFromWorkdrive(fileId);
      }
      returnObject["DataUrl"] = data;
      //setLoader(false);
    } catch (e) {
      //setLoader(false);
    }
    //setAuthenticatedUrl("https://firstprojectbook.herokuapp.com/static/pdf/Mediatek_2016_CSRreport.pdf")
    returnObject["ShowPrevModal"] = true;
    return returnObject;
  };

  return (
    <>
      <SubHeader
        clickActionOfSaveAndCancelButton={clickActionOfSaveAndCancelButton}
        dealListTriggers={dealListTriggers}
        dealListStatus={dealListStatus}
        clientListTriggers={clientListTriggers}
        clientListStatus={clientListStatus}
        getToken={getToken}
        helperFnGetTokenFromCode={helperFnGetTokenFromCode}
        sidebarCardsStatus={sidebarCardsStatus}
        params={routesParams}
        location={location}
        history={history}
        showExitPrompt={showExitPrompt}
        setShowExitPrompt={setShowExitPrompt}
        checkType={checkType}
        setCheckType={setCheckType}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        setDeleteDealFlag={setDeleteDealFlag}
      />
      <Switch>
        <Route path="/" exact render={(props) => <></>} />
        {/* <Route
        path="/report-bug"
        exact
        render={(props) => (
          <ReportBug {...props} location={location} history={history} />
        )}
      /> */}
        <Route
          path="/access/e/:module/:action"
          exact
          render={(props) => (
            <Email
              clickedFromBody={false}
              {...props}
              allUsers={allUsers}
              getParams={getParams}
            />
          )}
        />
        <Route
          path="/access/:module/:action"
          exact
          render={(props) => (
            <FullCalendar {...props} history={history} getParams={getParams} />
          )}
        />
        <Route
          path="/c/:module/:action/:id"
          exact
          render={(props) => (
            <ClientBody
              checkType={checkType}
              setCheckType={setCheckType}
              deleteDealFlag={deleteDealFlag}
              setDeleteDealFlag={setDeleteDealFlag}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              {...props}
              getParams={getParams}
              location={location}
              history={history}
            />
          )}
        />
        <Route
          path="/deallist/:module/:action"
          exact
          render={() => (
            <DealList
              checkType={checkType}
              setCheckType={setCheckType}
              fetchAuthenticatedUrl={fetchAuthenticatedUrl}
              dealListTriggers={dealListTriggers}
              dealListStatus={dealListStatus}
              deleteDealFlag={deleteDealFlag}
              setDeleteDealFlag={setDeleteDealFlag}
              setRendering={setRendering}
              rendering={rendering}
              getParams={getParams}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              location={location}
            />
          )}
        />
        <Route
          path="/dealcreate/:module/:action"
          exact
          render={(props) => (
            <Createdeal
              setLoader={setLoader}
              getToken={getToken}
              toggelActiveBar={toggelActiveBar}
              ref={saveCancelButtonRef}
              fetchAuthenticatedUrl={fetchAuthenticatedUrl}
              setSidebarCardsStatus={setSidebarCardsStatus}
              {...props}
              getParams={getParams}
              location={location}
              history={history}
              showExitPrompt={showExitPrompt}
              setShowExitPrompt={setShowExitPrompt}
            />
          )}
        />
        <Route
          path="/dealupdate/:module/:action/:id"
          exact
          render={(props) => (
            <Createdeal
              setLoader={setLoader}
              getToken={getToken}
              toggelActiveBar={toggelActiveBar}
              ref={saveCancelButtonRef}
              fetchAuthenticatedUrl={fetchAuthenticatedUrl}
              setSidebarCardsStatus={setSidebarCardsStatus}
              {...props}
              getParams={getParams}
              location={location}
              history={history}
              showExitPrompt={showExitPrompt}
              setShowExitPrompt={setShowExitPrompt}
            />
          )}
        />
        <Route
          path="/d/:module/:action/:id"
          exact
          render={(props) => (
            <Body
              setLoader={setLoader}
              deleteDealFlag={deleteDealFlag}
              setDeleteDealFlag={setDeleteDealFlag}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              {...props}
              setRendering={setRendering}
              rendering={rendering}
              checkType = {checkType}
              setCheckType = {setCheckType}
              dealListStatus = {dealListStatus}
              dealListTriggers = {dealListTriggers}
              getParams={getParams}
              location={location}
              history={history}
              allUsers={allUsers}
            />
          )}
        />
        <Route
          path="/clientlist/:module/:action"
          exact
          render={(props) => (
            <ClientList
              clientListTriggers={clientListTriggers}
              deleteDealFlag={deleteDealFlag}
              setDeleteDealFlag={setDeleteDealFlag}
              clientListStatus={clientListStatus}
              {...props}
              getParams={getParams}
              location={location}
              history={history}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
            />
          )}
        />
        <Route
          path="/project/:module/:action/:taskId?/:subTaskId?"
          exact
          render={(props) => (
            <Suspense fallback={<SkeletonUIHeader/>}>
              <ProjectTasks
                {...props}
                getParams={getParams}
                location={location}
                history={history}
                // clientListStatus={clientListStatus}
                // clientListTriggers={clientListTriggers}
              />
            </Suspense>
          )}
        />
        <Route
          path="/createclient/:module/:action"
          exact
          render={(props) => (
            <CreateClient
              clientListStatus={clientListStatus}
              setClientListStatus={setClientListStatus}
              {...props}
              getParams={getParams}
              location={location}
              history={history}
            />
          )}
        />
        <Route
          path="/updateclient/:module/:action/:id"
          exact
          render={(props) => (
            <CreateClient
              clientListStatus={clientListStatus}
              setClientListStatus={setClientListStatus}
              {...props}
              getParams={getParams}
              location={location}
              history={history}
            />
          )}
        />

        <Route
          path="/setting/pipeline/:taskId?/:subTaskId?"
          exact
          render={(props) => (
            <Suspense fallback={<SkeletonUIHeader/>}>
              <ProjectTasks
                {...props}
                getParams={getParams}
                location={location}
                history={history}
                // clientListTriggers={clientListTriggers}
              />
            </Suspense>
          )}
        />
        <Route
          path="/access/d/:module/:action"
          exact
          render={(props) => (
            <DocumentTree
              {...props}
              location={location}
              history={history}
              getParams={getParams}
            />
          )}
        />
        <Route
          path="/setting/index"
          exact
          render={() => <Setting location={location} history={history} />}
        />
        <Route
          path="/setting/users/:id/:tab"
          exact
          render={(props) => (
            <Users
              {...props}
              getParams={getParams}
              location={location}
              history={history}
            />
          )}
        />
        <Route
          path="/vendorlist/:module/:action"
          exact
          render={(props) => (
            <VendorList
              {...props}
              getParams={getParams}
              location={location}
              history={history}
            />
          )}
        />
        <Route
          path="/vendorcreate/:module/:action"
          exact
          render={(props) => (
            <CreateVendor
              {...props}
              getParams={getParams}
              location={location}
              history={history}
            />
          )}
        />
        <Route
          path="/vendorupdate/:module/:action/:id"
          exact
          render={(props) => (
            <CreateVendor
              {...props}
              getParams={getParams}
              location={location}
              history={history}
            />
          )}
        />
        <Route
          path="/setting/taskflows/:ROWID?"
          exact
          render={(props) => (
            <TaskBlueprints
              getParams={getParams}
              location={location}
              history={history}
            />
          )}
        />
        <Route
          path="/setting/emailTemplate"
          exact
          render={(props) => (
            <EmailTemplates
              getParams={getParams}
              location={location}
              history={history}
              selectedEdgeData={""}
              editTemplate={""}
              flowId={"1"}
            />
          )}
        />
        <Route
          path="/hr/timeclock"
          exact
          render={(props) => (
            <HRTimeClock
              {...props}
              getParams={getParams}
              location={location}
              history={history}
            />
          )}
        />
        <Route
          path="/setting/teams"
          exact
          render={(props) => <Teams location={location} history={history} />}
        />
        <Route
          path="/setting/SecurityControl"
          exact
          render={(props) => <ApplicationProfiles location={location} history={history} />}
        />
        <Route
          path="/setting/userroles"
          exact
          render={(props) => <UserRole location={location} history={history} />}
        />
        <Route
          path="/setting/roles"
          exact
          render={(props) => <Roles location={location} history={history} />}
        />

        {/*        
              {/*
              <Route path="/app/pvmodule/list" exact render={() => <PVModuleList />} />
              <Route path="/app/pvmanufacturer/list" exact render={() => <PVManufacturerList />} />
              <Route path="/app/pipeline/list" exact render={() => <PipelineList />} />
              <Route path="/app/pipelines/create" exact render={() => <PipelineForm />} />
              <Route path="/app/pipeline/update/:id" exact render={() => <PipelineForm />} />
              <Route path="/app/holidays/list" component={HolidaysList} /> */}
      </Switch>
    </>
  );
};
export default AppRoutes;
